import React from 'react';
import AnErrorOccured from '../../modules/maintenance/AnErrorOccured';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidMount() {
    window.addEventListener('unhandledrejection', this.handleUnhandledRejection);
  }

  componentWillUnmount() {
    window.removeEventListener('unhandledrejection', this.handleUnhandledRejection);
  }

  handleUnhandledRejection = (event) => {
    console.error('Unhandled promise rejection caught by ErrorBoundary:', event.reason);
    // Ignore harmless network timeouts, but catch structural async crashes
    if (event.reason && event.reason.name !== 'CanceledError') {
      this.setState({ hasError: true });
    }
  };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return <AnErrorOccured />;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
